/**
 * Wordmark — the Syncreel logotype (Netflix-red, bold, tracked caps).
 * Renders a link to the landing page unless `to` is null.
 */
import { Link } from 'react-router-dom';

export interface WordmarkProps {
  size?: 'sm' | 'md' | 'lg';
  /** Destination; pass null for a non-interactive mark. */
  to?: string | null;
}

/** Syncreel logotype. */
export function Wordmark({ size = 'md', to = '/' }: WordmarkProps) {
  const cls = `wordmark${size === 'lg' ? ' wordmark--lg' : size === 'sm' ? ' wordmark--sm' : ''}`;
  if (to === null) return <span className={cls}>Syncreel</span>;
  return (
    <Link to={to} className={cls} aria-label="Syncreel home">
      Syncreel
    </Link>
  );
}
